module.exports = __webpack_public_path__ + "thumbnail.3d9dab97.png";